import React, { useEffect, useState } from "react";

import "./Dashboard.scss";
import AvailableFunds from "Components/AvailableFunds/AvailableFunds";
import DashboardLinks from "Components/DashboardLink/DashboardLinks";
import LoadVipAccount from "Components/LoadVipAccount";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import useSession from "Utils/Hooks/useSession";
import AppLogout from "Utils/Hooks/AppLogout";
import { FUND_SOURCE_TYPE, PRODUCTTYPES } from "Utils/Constants";
import { FindMatchedFundingSource } from "Utils/Utils";
import { Box } from "@mui/material";

const Dashboard = () => {
  const { session } = useSession();
  const productType =
    session?.patronProductType === PRODUCTTYPES.PREFERRED ? "VIPP" : "VIPO";
  document.title = productType + " - Dashboard";
  const vipApi = useVipApiFetcher();
  const [fundingSource, setFundingSource] = useState(null);

  useEffect(() => {
    if (session?.patronProductType === PRODUCTTYPES.ONLINE) {
      const selectedFundDetails = window.sessionStorage.getItem(
        "selectedFundDetails",
      )
        ? JSON.parse(window.sessionStorage.getItem("selectedFundDetails"))
        : null;
      vipApi.fetchData("/api/bank/ach").then((fundList) => {
        const plaidFundList = fundList.filter(
          (fund) =>
            (fund.achOpenType === FUND_SOURCE_TYPE.PLAID.toLocaleLowerCase() ||
              fund.achOpenType === FUND_SOURCE_TYPE.FINICITY) &&
            fund.availableLimit,
        );
        if (plaidFundList.length > 0) {
          if (selectedFundDetails) {
            const selectedFundingSource = FindMatchedFundingSource(
              fundList,
              selectedFundDetails,
            );
            setFundingSource(selectedFundingSource);
          } else {
            setFundingSource(plaidFundList[0]);
          }
        }
      });
    }
  }, [vipApi.ready]);

  return (
    <AppLogout>
      <LoadVipAccount>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "32px" }}>
          <AvailableFunds fundingSource={fundingSource} />
          <DashboardLinks />
        </Box>
      </LoadVipAccount>
    </AppLogout>
  );
};

export default Dashboard;
